/**
 * @generated SignedSource<<ac15e81e70060402957d47e344078514>>
 * @relayHash b1c5bff520163b91e48e77e975abc312
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useATLGeneralWebPanelObserverSpaceThemeQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type useATLGeneralWebPanelObserverSpaceThemeQuery$data = {
  readonly space: {
    readonly id: string | null | undefined;
    readonly theme: {
      readonly themeKey: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useATLGeneralWebPanelObserverSpaceThemeQuery = {
  response: useATLGeneralWebPanelObserverSpaceThemeQuery$data;
  variables: useATLGeneralWebPanelObserverSpaceThemeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "Theme",
        "kind": "LinkedField",
        "name": "theme",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "themeKey"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b1c5bff520163b91e48e77e975abc312",
    "id": "808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47",
    "metadata": {},
    "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
    "operationKind": "query",
    "text": "query useATLGeneralWebPanelObserverSpaceThemeQuery($spaceKey:String){space(key:$spaceKey){id,theme{themeKey}}}"
  }
};
})();

(node as any).hash = "5414d0003b526de29b97ae12c29148ab";

export default node;
